import React, { useState } from "react";
import { apiFetchJson } from "../api";
import { t } from "../i18n";
import { KeyIcon, Spinner } from "./Icons";

// Поле «ключ подписки» и кнопка «Активировать» — в настройках и на экране
// «Подписка не активна». Ключ вида UMB-XXXX-XXXX-XXXX выдаёт администратор
// (розыгрыш, подарок); сервер проверяет его и добавляет дни к подписке
// (/api/subscription/redeem). Регистр, пробелы и дефисы не важны — сервер
// приводит ключ к виду сам, поле только переводит буквы в заглавные.
//
// onRedeemed получает ответ сервера: { days, subscription, … }.
const RedeemKeyForm = ({ onRedeemed, autoFocus = false, className = "" }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    const value = code.trim();
    if (busy) return;
    if (!value) {
      setError(t("Введите ключ — он выглядит так: UMB-XXXX-XXXX-XXXX."));
      return;
    }
    setBusy(true);
    setError("");
    try {
      const response = await apiFetchJson("/api/subscription/redeem", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: value }),
        timeoutMs: 20000,
        retry: false
      });
      setCode("");
      await onRedeemed?.(response);
    } catch (requestError) {
      setError(requestError?.message || t("Не удалось активировать ключ"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className={`rk-form${className ? ` ${className}` : ""}`} onSubmit={submit} noValidate>
      <div className="rk-row">
        <label className="rk-field" data-error={error ? "1" : "0"}>
          <KeyIcon size={15} />
          <input
            type="text"
            value={code}
            onChange={(event) => {
              setCode(event.target.value.toUpperCase().replace(/[^A-Z0-9\s-]/g, "").slice(0, 24));
              if (error) setError("");
            }}
            placeholder="UMB-XXXX-XXXX-XXXX"
            aria-label={t("Ключ подписки")}
            autoComplete="off"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
            autoFocus={autoFocus}
            disabled={busy}
          />
        </label>
        <button type="submit" className="rk-submit" disabled={busy}>
          {busy && <Spinner size={14} />}
          {busy ? t("Проверяем...") : t("Активировать")}
        </button>
      </div>
      {error && <div className="rk-error" role="alert">{error}</div>}
    </form>
  );
};

export default RedeemKeyForm;
